var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { WHITE } from '../../../theme/colors';
var ActionButton = function (_a) {
    var variant = _a.variant, height = _a.height, width = _a.width, fontSize = _a.fontSize, children = _a.children, buttonProps = _a.buttonProps, onClick = _a.onClick;
    var useStyles = makeStyles(function (theme) { return ({
        root: {
            height: height || 36,
            width: width || 96,
            fontSize: fontSize || 15,
            borderRadius: 9,
            fontWeight: 500,
            textTransform: 'none',
        },
        primary: {
            backgroundColor: theme.palette.primary.main,
            '& .MuiButton-label': {
                color: WHITE,
            },
            '&:hover': {
                backgroundColor: theme.palette.primary.main,
                opacity: 0.8,
            },
        },
        secondary: {
            border: "2px solid " + theme.palette.primary.main,
            '& .MuiButton-label': {
                color: theme.palette.primary.main,
            },
            '&:hover': {
                backgroundColor: 'transparent',
                opacity: 0.8,
            },
        },
    }); });
    var classes = useStyles();
    return (React.createElement(Button, __assign({ variant: variant === 'primary' ? 'contained' : 'outlined', color: "primary", disableElevation: true }, buttonProps, { className: classes.root + " " + classes[variant] + " " + (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className), onClick: onClick }), children));
};
export default ActionButton;
//# sourceMappingURL=index.js.map